// biome-ignore lint/style/useImportType: legacy import, will be migrated
import { MenuBackgroundState } from './types';

// Option classnames
const BUTTON = 'button-base';

export const BASE_BOX =
  'inline-flex flex-shrink-0 justify-between items-center w-full h-56 px-16';

export const OPTION_WRAPPER =
  'inline-flex flex-col h-full w-full overflow-auto rounded-5';

export const OPTION = `${BUTTON} ${BASE_BOX} text-base-main bg-white hover:text-primary-main hover:bg-gray-lighter`;
export const OPTION_DARK = `${BUTTON} ${BASE_BOX} text-gray-light bg-neutral-dark-700 hover:text-white hover-bg-neutral-dark-600`;
export const OPTION_TRANSPARENCY = `${BUTTON} ${BASE_BOX} text-white hover:text-base-main hover:bg-white`;

export const BACKGROUND_COLOR_CLASSNAMES: {
  [key in MenuBackgroundState]: string;
} = {
  light: 'bg-white',
  dark: 'bg-neutral-dark-700',
  transparency: 'bg-base-main',
};
